import React from "react";

import styles from "./FormElement.module.scss";

/**
 *
 * @param {String} labelText - Text displayed between opening and closing label tag
 * @param {String} [className] - additional className to add
 * @param {String} htmlFor - associated with (same as) an input's name
 * @param {String} errorMessage - an error message to display
 * @param {String} children - props.children
 * @param {Boolean} [info] - whether to show info icon
 * @param {String} smallText - small text to add after label
 */
const FormElement = ({
    className,
    labelText,
    htmlFor,
    errorMessage,
    children,
    info,
    smallText
}) => {
    return (
        <div className={`${styles["form-group"]} ${className || ""}`}>
            {labelText && htmlFor ? (
                <label htmlFor={htmlFor}>
                    {labelText}{" "}
                    {smallText ? (
                        <span className={styles["small-text"]}>
                            {smallText}
                        </span>
                    ) : (
                        ""
                    )}
                </label>
            ) : (
                ""
            )}
            {children}
            {errorMessage ? (
                <p className={styles["form-error-message"]}>{errorMessage}</p>
            ) : (
                ""
            )}
            {/* TODO: ADD text and event handler props to info once you know what they should do */}
            {/* {info ? (
                <i className={`fal fa-info-circle ${styles["info-icon"]}`} />
            ) : (
                ""
            )} */}
        </div>
    );
};

export default FormElement;
